<template lang="pug">
  v-row
    v-col(cols="12" sm="12" lg="5")
      v-card(flat)
        v-card-title.text-h5 Персональные данные
        v-card-text
          api-form(
            v-model="formValuesPersonal"
            :autosave="!userData.is_local"
            :fields="fieldsPersonal"
            :defaultAttrs="{filled: true,rounded: true}"
            :method="saveSettingsPersonal"
            :inital="initialSettingsPersonal"
            :btn-props="{ rounded: true, color: 'success' }"
          )
    v-col(cols="12" lg="7")
      v-card.sdo-card(max-height="80vh")
        v-card-title.grey.lighten-4
          v-tabs(v-model="tab" grow ).grey.lighten-4
            v-tab.grey.lighten-4(v-if="$user.isOrganization")
              v-icon(left) mdi-account-details
              span Данные организации
            v-tab.grey.lighten-4
              v-icon(left) $telegram
              span telegram
            v-tab.grey.lighten-4
              v-icon(left) mdi-lock-open
              span Изменить пароль

        v-card-text.overflow-y-auto.scroll(style="height: 100%")
          v-tabs-items(v-model="tab")
            v-tab-item(v-if="$user.isOrganization")
              v-card(flat)
                v-card-text
                  v-alert(type="info" v-if="!userData.is_local").
                    Редактирование этих полей осуществляется в системе ПФДО

                template
                  v-card-title Данные организации
                  v-card-text
                    api-form(
                      v-model="formValues"
                      :autosave="!userData.is_local"
                      :fields="fields"
                      :defaultAttrs="{filled: true,rounded: true}"
                      :method="saveSettings"
                      :inital="initialSettings"
                      :btn-props="{ rounded: true, color: 'success' }"
                    )
            v-tab-item
              set-telegram.pa-5.mb-5
            v-tab-item
              change-password
      //- v-row
      //-   v-col(cols=12 md=6)
          set-telegram.pa-5.mb-5

        v-col( md=6)
          v-card.sdo-card
            v-card-title Изменить пароль
          //- v-card.sdo-card(
          //-   max-height="80vh"
          //- ).overflow-y-auto.scroll
          //-   v-card-title Персональные данные
          //-   v-card-text
          //-     v-alert(type="info" v-if="!userData.is_local").sticky.
          //-       Редактирование этих полей осуществляется в системе ПФДО
          //-     api-form(
          //-       v-model="formValues"
          //-       :autosave="!userData.is_local"
          //-       :fields="fields"
          //-       :defaultAttrs="{filled: true,rounded: true}"
          //-       :method="saveSettings"
          //-       :inital="initialSettings"
          //-       :btn-props="{ rounded: true, color: 'success' }"
          //-     )

</template>

<script>
import { mapGetters } from 'vuex';

import OrganizationTypeSelect from '@/components/InputFields/organization/OrganizationTypeSelect.vue';
import FileUpload from '@/components/InputFields/FileUpload.vue';
import SetTelegram from '../components/SetTelegram.vue';
import ChangePassword from '../components/ChangePassword.vue';

export default {
  name: 'UserSettings',
  components: {
    OrganizationTypeSelect,
    ChangePassword,
    SetTelegram,
  },
  data() {
    return {
      tab: 0,
      orgForms: [],
      providerTypes: [],
      subordinationLevels: [],
      formValuesPersonal: {},
      formValues: {
        licenses: {
          file_name: '',
          url: '',
        },
        documents: {
          url: '',
          file_name: '',
        },
      },
      initialSettingsPersonal: {

      },
      initialSettings: {
        licenses: {
          file_name: '',
          url: '',
        },
        documents: {
          url: '',
          file_name: '',
        },
      },
    };
  },
  computed: {
    ...mapGetters({ userData: 'auth/userData' }),
    fieldsPersonal() {
      return [
        {
          text: 'Фамилия пользователя',
          value: 'information_surname',
          component: 'v-text-field',
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Имя пользователя',
          value: 'information_first_name',
          component: 'v-text-field',
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Отчество пользователя',
          value: 'information_patronymic',
          component: 'v-text-field',
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Почта',
          value: 'email',
          component: 'v-text-field',
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
      ];
    },
    fields() {
      const result = [
        {
          text: 'Организационно правовая форма',
          value: 'organization_form',
          component: 'v-select',
          component_attrs: {
            items: this.orgForms,
            'item-text': 'name',
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Фактический адрес',
          value: 'address_actual',
          component: 'v-text-field',
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Юридический адрес совпадает с фактичестким',
          value: 'isAddressSame',
          component: 'v-checkbox',
          component_attrs: {
            class: 'pt-0 pl-2 mt-0',
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Юридический адрес',
          value: 'address_legal',
          component: 'v-text-field',
          condition: this.formValues.isAddressSame,
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Тип поставщика',
          value: 'type',
          component: OrganizationTypeSelect,
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Тип организации',
          value: 'form',
          component: 'v-select',
          component_attrs: {
            'item-text': 'name',
            items: this.providerTypes,
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Уровень подчиненности',
          value: 'level',
          component: 'v-select',
          component_attrs: {
            'item-text': 'level',
            items: this.subordinationLevels,
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Адрес сайта',
          value: 'contact_site_url',
          rules: 'url',
          component: 'v-text-field',
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Имя Директора',
          value: 'director_first_name',
          component: 'v-text-field',
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Номер телефона',
          value: 'contact_phone',
          component: 'v-text-field',
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Контактное лицо',
          value: 'contact_person',
          component: 'v-text-field',
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'ИНН',
          value: 'payment_inn',
          component: 'v-text-field',
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Банковский счет',
          value: 'payment_bill',
          component: 'v-text-field',
          component_attrs: {
            disabled: !this.userData.is_local,
          },
        },
        {
          text: 'Лицензия',
          value: 'licenses',
          component: FileUpload,
          component_attrs: {
            class: 'py-0 my-0',
            ref: 'fileUploaderLic',
            hint: 'Допустимые виды файлов: png, jpg, pdf, pptx, docx, doc. Максимальный размер 64 МБ',
            multiple: true,
            vid: 'file',
            name: 'Файл',
            'existing-file-name': this.formValues.licenses.file_name,
            'existing-file-url': this.formValues.licenses.url,
            disabled: !this.userData.is_local,
          },
        // component_events: {
        //   'file:changed': this.addFile,
        // },
        },
        {
          text: 'Документы',
          value: 'documents',
          component: FileUpload,
          component_attrs: {
            ref: 'fileUploaderDoc',
            hint: 'Допустимые виды файлов: png, jpg, pdf, pptx, docx, doc. Максимальный размер 64 МБ',
            multiple: true,
            vid: 'file',
            name: 'Файл',
            'existing-file-name': this.formValues.documents.file_name,
            'existing-file-url': this.formValues.documents.url,
            disabled: !this.userData.is_local,
          },
        },
      ];
      return result;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.$user.isOrganization) {
        this.getInfo(this.userData.organizations[0].id);
        this.getOrgFormList();

        this.getProviderTypes();
        this.getSubordinationLevels();
      }
      this.getSelf();
    },
    resetForm() {
      this.formValues = { ...this.initialSettings };
    },
    resetFormsPersonal() {
      this.formValuesPersonal = { ...this.initialSettingsPersonal };
    },
    getSelf() {
      this.$rHandler(
        this.$api.users.getSelf(),
        (res) => {
          this.initialSettingsPersonal = {
            ...this.initialSettingsPersonal,
            ...res.data.data,
            information_first_name: res.data.data.info.first_name,
            information_surname: res.data.data.info.surname,
            information_patronymic: res.data.data.info.patronymic,
          };
          this.resetFormsPersonal();
        },
      );
    },
    getInfo(id) {
      this.$rHandler(
        this.$api.contacts.getInfo(id),
        (res) => {
          this.initialSettings = { ...this.initialSettings, ...res.data.data };
          this.resetForm();
        },
      );
    },

    getOrgFormList() {
      this.$rHandler(
        this.$api.dir.departmentsOrganizationalForms(),
        (r) => {
          this.orgForms = r.data.data;
        },
      );
    },
    getProviderTypes() {
      this.$rHandler(
        this.$api.dir.providerTypes(),
        (r) => {
          this.providerTypes = r.data.data;
        },
      );
    },
    getSubordinationLevels() {
      this.$rHandler(
        this.$api.dir.subordinationLevels(),
        (r) => {
          this.subordinationLevels = r.data.data;
        },
      );
    },
    saveSettings({ data, obs }) {
      if (this.$user.isOrganization && data.isAddressSame) {
        data.address_legal = data.address_actual;
      }
      data.info = { ...data };
      if (!this.$user.isOrganization && this.initialSettings.email === data.email) {
        delete data.email;
      }

      return this.$rHandler(
        this.$api.users.saveOrgSettings(
          this.$user.isOrganization ? this.userData.organizations[0].id : null, data,
        ),
        async () => { await this.$user.syncUser(); },
        (resp) => resp,
        obs,
      );
    },
    saveSettingsPersonal({ data, obs }) {
      data.info = { ...data };
      if (this.initialSettingsPersonal.email === data.email) {
        delete data.email;
      }

      return this.$rHandler(
        this.$api.users.saveUserSettings(data),
        async () => { await this.$user.syncUser(); },
        (resp) => resp,
        obs,
      );
    },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .theme--dark.v-tabs > .v-tabs-bar {
    background: none;
  }
  ::v-deep .theme--light.v-tabs > .v-tabs-bar {
    background: none;
  }
  .v-tab {
    font-weight: 700;
  }

</style>
